import React from 'react';
import SEO from '../components/SEO';
import '../styles/about-us.css';

function AboutUs() {
  return (
    <div className="about-us-page">
      <SEO 
        title="About Us | Lead With Tech - Professional Training & Career Development"
        description="Learn about Lead With Tech's mission to empower IT professionals through expert-led training in GitHub, Azure DevOps, and emerging technologies."
      />
      
      <section className="about-hero">
        <div className="container">
          <h1>About Lead With Tech</h1>
          <p>Empowering IT professionals with cutting-edge skills and knowledge</p>
        </div>
      </section>

      <section className="our-mission">
        <div className="container">
          <h2>Our Mission</h2>
          <p>At Lead With Tech, we are dedicated to empowering IT professionals with the skills and knowledge they need to excel in today's rapidly evolving technology landscape. Through expert-led training and comprehensive programs, we help individuals and organizations stay ahead of the curve in areas like GitHub, Azure DevOps, and emerging technologies.</p>
        </div>
      </section>

      <section className="our-approach">
        <div className="container">
          <h2>Our Approach</h2>
          <div className="approach-grid">
            <div className="approach-item">
              <h3>Expert-Led Training</h3>
              <p>Learn from industry professionals with extensive real-world experience in implementing and managing technology solutions.</p>
            </div>
            <div className="approach-item">
              <h3>Hands-on Learning</h3>
              <p>Gain practical experience through interactive sessions, real-world scenarios, and hands-on projects.</p>
            </div>
            <div className="approach-item">
              <h3>Comprehensive Programs</h3>
              <p>Access well-structured courses covering both fundamental concepts and advanced techniques.</p>
            </div>
            <div className="approach-item">
              <h3>Continuous Support</h3>
              <p>Receive ongoing guidance and support throughout your learning journey.</p>
            </div>
          </div>
        </div>
      </section>

      <section className="why-choose-us">
        <div className="container">
          <h2>Why Choose Lead With Tech?</h2>
          <div className="benefits-grid">
            <div className="benefit-item">
              <h3>Industry-Relevant Content</h3>
              <p>Our curriculum is constantly updated to reflect the latest industry trends and best practices.</p>
            </div>
            <div className="benefit-item">
              <h3>Flexible Learning Options</h3>
              <p>Choose from various learning formats that fit your schedule and learning style.</p>
            </div>
            <div className="benefit-item">
              <h3>Career Growth</h3>
              <p>Develop skills that directly impact your career progression and professional growth.</p>
            </div>
            <div className="benefit-item">
              <h3>Community Support</h3>
              <p>Join a community of like-minded professionals and expand your network.</p>
            </div>
          </div>
        </div>
      </section>

      <section className="our-values">
        <div className="container">
          <h2>Our Values</h2>
          <div className="values-grid">
            <div className="value-item">
              <h3>Excellence</h3>
              <p>We strive for excellence in every aspect of our training programs.</p>
            </div>
            <div className="value-item">
              <h3>Innovation</h3>
              <p>We embrace new technologies and innovative teaching methods.</p>
            </div>
            <div className="value-item">
              <h3>Integrity</h3>
              <p>We maintain the highest standards of professional integrity.</p>
            </div>
            <div className="value-item">
              <h3>Empowerment</h3>
              <p>We empower our learners to achieve their full potential.</p>
            </div>
          </div>
        </div>
      </section>

      <section className="join-us">
        <div className="container">
          <h2>Join Us on Your Learning Journey</h2>
          <p>Take the first step towards advancing your career in technology. Explore our programs and start your learning journey with Lead With Tech today.</p>
          <div className="cta-buttons">
            <a href="/programs" className="primary-button">View Our Programs</a>
            <a href="/contact" className="secondary-button">Contact Us</a>
          </div>
        </div>
      </section>
    </div>
  );
}

export default AboutUs;